"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePushEvent = void 0;

var _pushEvent = require("./pushEvent");

var _postAnalytics = require("./postAnalytics");

var pushEvent = (0, _pushEvent.makePushEvent)(_postAnalytics.makePostAnalytics);
exports.makePushEvent = pushEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@devicebits/analytics-client/dist/index.js
// module id = 968
// module chunks = 0